<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="消息通知名称">
          <el-input placeholder="请输入消息通知名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加消息通知</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
      
            <el-table-column prop="context" label="消息通知内容"></el-table-column>
            <el-table-column prop="code" label="消息通知类型">
              <template slot-scope="scope">
                <div v-if="scope.row.code == 'text'">内容</div>
                <!-- <div v-if="scope.row.code == 'image'">图片</div> -->
              </template>
            </el-table-column>
            <el-table-column prop="send_type" label="通知对象">
              <template slot-scope="scope">
                <div v-if="scope.row.send_type == 1">全站会员</div>
                <div v-if="scope.row.send_type == 3">指定会员</div>
              </template>
            </el-table-column>

            <el-table-column prop="send_type" label="发送类型">
              <template slot-scope="scope">
                <div v-if="scope.row.stype == 1">系统消息</div>
              </template>
            </el-table-column>

   
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="200">
              <template slot-scope="scope">
                <el-button @click="sendClick(scope.row)" v-if="scope.row.status != 1" type="text" size="small">发送消息</el-button>
                <el-button @click="editClick(scope.row)" type="text" size="small">详情</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :msg_id="msg_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  
  </div>
</template>

<script>
  import MsgApi from '@/api/msg.js';
  import UserApi from '@/api/user.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  const config = require('../../../../../config');  // 根据项目路径调整
  export default { 
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },
        open_add:false,
        open_edit:false,
        msg_id:"",
        dialogVisible:false,
        websocket: null,
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
    },
    mounted() {
    // 初始化 WebSocket
    // this.initWebSocket();
  },
  beforeDestroy() {
    // 组件销毁时关闭连接
    if (this.websocket) {
      this.websocket.close();
    }
  },
    methods: {
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//消息通知标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){     
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this; 
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        MsgApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
            console.log("列表",self.tableData);
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.msg_id = row.msg_id;
        this.open_edit = true
      },
      async sendClick(row) {
        var self = this
          try {
            console.log(row.send_type )
            var message = {};
            if(row.send_type == 1){//全站
              message = {
              to_type: row.send_type,
              content: row.context,
            };

            }else  if(row.send_type == 3){//
                message = {
                  to_type: row.send_type,
                  content: row.context,
                  users: row.user_ids
              };

            }
            UserApi.sendSystemMsg(
                message,
                true
              )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '系统通知已发送',
                    type: 'success'
                  });
                } else {
                  self.$message.error('系统通知发送失败');
                }
              });
        } catch (error) {
          console.error('发送失败:', error);
          this.$message.error(`发送失败: ${error.message}`);
        }

      },
      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            MsgApi.del(
              {
                msg_id: row.msg_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/msg/index/index.vue